<svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M0.659106 0.269583C0.299662 0.629028 0.299662 1.2118 0.659106 1.57125L3.58786 4.5L0.658255 7.42961C0.298811 7.78906 0.298811 8.37183 0.658255 8.73128C1.0177 9.09072 1.60047 9.09072 1.95992 8.73128L4.88953 5.80167L7.81825 8.7304C8.1777 9.08984 8.76047 9.08984 9.11992 8.7304C9.47936 8.37095 9.47936 7.78818 9.11992 7.42873L6.19119 4.5L9.11907 1.57213C9.47851 1.21268 9.47851 0.62991 9.11907 0.270465C8.75962 -0.0889791 8.17685 -0.0889792 7.8174 0.270465L4.88953 3.19834L1.96077 0.269583C1.60133 -0.089861 1.01855 -0.0898613 0.659106 0.269583Z"
    fill="#112334"
  />
</svg>
